__turbopack_context__.v({
  "base": "PrimaryEditBar-module__BiAjlq__base",
  "clearButton": "PrimaryEditBar-module__BiAjlq__clearButton",
  "ctaContainer": "PrimaryEditBar-module__BiAjlq__ctaContainer",
  "desktop": "PrimaryEditBar-module__BiAjlq__desktop",
  "dividerWrapper": "PrimaryEditBar-module__BiAjlq__dividerWrapper",
  "floatingEditBar": "PrimaryEditBar-module__BiAjlq__floatingEditBar",
  "hasValue": "PrimaryEditBar-module__BiAjlq__hasValue",
  "mobile": "PrimaryEditBar-module__BiAjlq__mobile",
  "mobilePill": "PrimaryEditBar-module__BiAjlq__mobilePill",
  "mobilePillsContainer": "PrimaryEditBar-module__BiAjlq__mobilePillsContainer",
  "mobileSearchContainer": "PrimaryEditBar-module__BiAjlq__mobileSearchContainer",
  "mobileSearchField": "PrimaryEditBar-module__BiAjlq__mobileSearchField",
  "mobileSearchFieldContainer": "PrimaryEditBar-module__BiAjlq__mobileSearchFieldContainer",
  "originPill": "PrimaryEditBar-module__BiAjlq__originPill",
  "placeholderContainer": "PrimaryEditBar-module__BiAjlq__placeholderContainer",
  "placeholderContainerWithSparkle": "PrimaryEditBar-module__BiAjlq__placeholderContainerWithSparkle",
  "searchFieldError": "PrimaryEditBar-module__BiAjlq__searchFieldError",
  "sparkleIcon": "PrimaryEditBar-module__BiAjlq__sparkleIcon",
  "textField": "PrimaryEditBar-module__BiAjlq__textField",
  "textFieldContainer": "PrimaryEditBar-module__BiAjlq__textFieldContainer",
  "textFieldContainerExpanded": "PrimaryEditBar-module__BiAjlq__textFieldContainerExpanded",
  "textFieldIcon": "PrimaryEditBar-module__BiAjlq__textFieldIcon",
  "toolbarReplacement": "PrimaryEditBar-module__BiAjlq__toolbarReplacement",
});
